import PropTypes from 'prop-types';
import React from 'react';
import SideBar from '../SideBar/index.js';
import SideBarHeader from '../SideBarHeader/index.js';
import Modal from '../Modal/index.js';
import ModalBody from '../ModalBody/index.js';
import ModalFooter from '../ModalFooter/index.js';
import ModalHeader from '../ModalHeader/index.js';
import ModalTitle from '../ModalTitle/index.js';
import ModalScrollPanel from '../ModalScrollPanel/index.js';

/**
 *  The SideBarToModal component switches between a SideBar and a Modal
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SideBarToModal(_ref) {
  let {
    collapsed = true,
    container,
    // For Syndicated Calc
    content,
    footerContent,
    modalOptions,
    onHide,
    show = false,
    sideBarOptions,
    title,
    ...rest
  } = _ref;
  const {
    action
  } = sideBarOptions;
  const renderSideBar = /*#__PURE__*/_jsx(SideBar, {
    show: show,
    onHide: onHide,
    header: /*#__PURE__*/_jsx(SideBarHeader, {
      title: title,
      onHide: onHide,
      action: action
    }),
    ...sideBarOptions,
    children: /*#__PURE__*/_jsx("div", {
      className: "padding-horizontal-3",
      children: content.sideBar ? content.sideBar : content
    })
  });
  const getModalBody = () => {
    const modalContent = content.modal ? content.modal : content;
    const contentWithScrollPanel = /*#__PURE__*/_jsx(ModalScrollPanel, {
      children: modalContent
    });
    return modalOptions.scrollPanel ? contentWithScrollPanel : modalContent;
  };
  const renderModal = /*#__PURE__*/_jsxs(Modal, {
    bsStyle: modalOptions.bsStyle,
    bsSize: modalOptions.bsSize,
    show: show,
    onHide: onHide,
    container: container,
    children: [/*#__PURE__*/_jsx(ModalHeader, {
      closeButton: true,
      children: /*#__PURE__*/_jsx(ModalTitle, {
        children: title
      })
    }), /*#__PURE__*/_jsx(ModalBody, {
      children: getModalBody()
    }), footerContent && /*#__PURE__*/_jsx(ModalFooter, {
      children: footerContent
    })]
  });
  return show && /*#__PURE__*/_jsx("div", {
    "data-cmp": "sideBarToModal",
    ...rest,
    children: collapsed && !container ? renderSideBar : renderModal
  });
}
export default SideBarToModal;